export default "__VITE_ASSET__ytVSyL5D__"